import React, {Component} from 'react'
// import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {CenteredWrapper, Container} from '../../../pages/styles'
import {Img, ImgContainer, NotFoundContainer, Text, Title} from './styles'
import {Button} from "finform";
import {Url} from "finhelper"

import swan from './images/swan.svg';

class UnexpectedError extends Component
{
  constructor(props) {
    super(props);

    this.state = {
      statuses: []
    };

  }

  componentDidMount()
  {
    // window.scrollTo(0, 0);
  }

  render()
  {
    let url = Url.getCurrentUrl();

    return <Container style={{
      margin: '20px auto 0 auto'
    }}>
      <CenteredWrapper>
        <NotFoundContainer>
          <ImgContainer>
            <Img src={swan}/>
          </ImgContainer>
          <Title>Ошибка</Title>
          <Text>Сообщите нам об ошибке info@blackswan.finance</Text>
          <Text></Text>
          <Button className='style1' type='href' href={url.indexOf('/cabinet') !== -1 ? '/cabinet' : '/'}>На главную</Button>
        </NotFoundContainer>
      </CenteredWrapper>
    </Container>
  }

}

const enhance = connect(
  (state) => ({  }),
  {}
)
export default enhance(UnexpectedError);
// export default withRouter(enhance(UnexpectedError))
